/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: '/dashboard',
    name: 'Dashboard',
    slug: 'dashboard'
  },
  {
    url: '/property-management',
    name: 'Property Management',
    slug: 'propertymanagement'
  },
  {
    url: '/orders',
    name: 'Orders',
    slug: 'orders'
  },
  {
    url: '/wholesale',
    name: 'Whole Sale',
    slug: 'wholesale'
  },
  {
    url: '/menu',
    name: 'Menu',
    slug: 'menu'
  },
  {
    url: '/contents',
    name: 'Contents',
    slug: 'contents'
  },
  {
    url: '/profile',
    name: 'Profile',
    slug: 'profile'
  },
  {
    url: '/hours',
    name: 'Hours',
    slug: 'hours'
  },
  {
    url: '/delivery-boundary',
    name: 'Delivery Boundary',
    slug: 'delivery-boundary'
  },
  {
    url: '/reviews',
    name: 'Reviews',
    slug: 'reviews'
  },
  {
    name: 'Register',
    submenu: [
      {
        url: '/register-admin',
        name: 'Register Administrator',
        slug: 'register-admin',
        i18n: 'Register Administrator'
      },
      {
        url: '/register-restaurant',
        name: 'Register Restaurant',
        slug: 'register-restaurant',
        i18n: 'Register Restaurant'
      }
    ]
  },
  {
    url: '/promotions',
    name: 'Promotions',
    slug: 'promotions',
    submenu: [
      {
        url: '/promotions-reporting',
        name: 'Reporting',
        slug: 'promotions-reporting',
        i18n: 'Reporting'
      },
      {
        url: '/promotions-manage',
        name: 'Manage',
        slug: 'promotions-manage',
        i18n: 'Manage'
      }
    ]
  },
  {
    url: '/financials',
    name: 'Financials',
    slug: 'financials',
    submenu: [
      {
        url: '/statements',
        name: 'Statements',
        slug: 'statements',
        i18n: 'Statements'
      },
      {
        url: '/transactions',
        name: 'Transactions',
        slug: 'transactions',
        i18n: 'Transactions'
      },
      {
        url: '/deposit-history',
        name: 'Deposit History',
        slug: 'deposit-history',
        i18n: 'Deposit History'
      },
      {
        url: '/current-balance',
        name: 'Current Balance',
        slug: 'current-balance',
        i18n: 'Current Balance'
      }
    ]
  }
]
